<div class="dialog-panel message-dialog">
  <div class="icon-close" [inlineSVG]="'/icons/icon-close.svg'" (click)="closeDialog()"></div>
  <div class="dialog-content">
    @if (loading) {
      <div class="spinner-container p-absolute">
        <mat-spinner class="primary" [diameter]="30"></mat-spinner>
      </div>
    }
    <div class="dialog-header">
      <h1 class="dialog-title">{{ data.title | transloco }}</h1>
    </div>
    <p class="mt-3 mb-4">{{ data.confirmQuestion | transloco }}</p>
    <div class="row">
      <div class="col-6">
        <button class="btn btn-primary btn-pink w-100" (click)="confirm()">{{ 'global.yes' | transloco }}</button>
      </div>
      <div class="col-6">
        <button class="btn btn-primary btn-pink w-100" (click)="closeDialog()">{{ 'global.no' | transloco }}</button>
      </div>
    </div>
  </div>
</div>
